module.exports = __webpack_public_path__ + "static/img/Vista_xiaochengxu.193a3ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/Vista_xiaochengxu.png
// module id = yIp5
// module chunks = 16